import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { IQuestionnaire, QuestionnaireType } from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { IDateObject } from "../objects";
import { IQuestionnairePropertyEditable } from "../properties";
import { DateObjectEditor } from "./DateObjectEditor";

export class QuestionnaireDateObjectEditor extends DateObjectEditor implements IQuestionnairePropertyEditable {
  constructor(source: IDateObject | QuestionnaireDateObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._questionnaire = this.createPropertyEditor(s => s.questionnaire, (s, v) => s.questionnaire = v);
  }

  protected _questionnaire: IPropertyEditable<IQuestionnaire>;

  questionnaire(): IPropertyEditable<IQuestionnaire> {
    return this._questionnaire;
  }

  selectableQuestionnaireTypes(): (QuestionnaireType | undefined)[] {
    const questionnaire = this._questionnaire.getValue();
    switch (questionnaire.type) {
      case "date":
        return ["date"];
      case "dateTime":
        return ["dateTime"];
      case "time":
        return ["time"];
      default:
        return [];
    }
  }

  getTypeName(): string {
    const questionnaire = this._questionnaire.getValue();
    switch (questionnaire.type) {
      case "date":
        return "日付";
      case "dateTime":
        return "日時";
      case "time":
        return "時刻";
      default:
        return "";
    }
  }

  clone(): IFormatObjectEditable {
    return new QuestionnaireDateObjectEditor(this);
  }
}
